import { Common } from "../lib/common-methods";
import { ReservationTag, ReservationTagCategory } from "./reservation-tag";
import { TagType } from "./tag-type";

export interface TagsRootDTO {
    categories: CategoryTagDTO[];

    ErrorCode?: any;
    ErrorDescription?: any;
}

export type TagOperationType = "CREATE" | "EDIT" | "DELETE" | "NONE";

export interface CategoryTagDTO {
    categoryOrder: number;
    categoryType: TagType
    color: string;
    id: string;
    restaurantId: string;
    title: string;
    tags: TagDTO[];

    op?: TagOperationType;
}

export interface TagDTO {
    categoryId: string;
    id: string;
    rule: string;
    tagOrder: number;
    title: string;
    timeperformed?: number;

    op?: TagOperationType;
}

export interface BatchCategoryUpdate {
    restaurantId: string;
    batchUpdateTagCategories: CategoryTagDTO[];
}

export const createTagCategoryUpdateDTO = (restaurantId: string, category: ReservationTagCategory, tagType: TagType): BatchCategoryUpdate => {
    let isNew = Common.isNullOrEmpty(category.id);
    //const order = isNew ? this.categories.map(c => c.order ?? 0).sort((a, b) => b - a)[0] + 1 : category.order;
    const order = -1;
    return {
        restaurantId: restaurantId,
        batchUpdateTagCategories: [
            {
                id: isNew ? "" : category.id + "",
                restaurantId: restaurantId,
                title: category.name,
                color: category.color,
                categoryOrder: order ?? 0,
                categoryType: tagType,
                op: isNew ? "CREATE" : "EDIT",
                tags: []
            }
        ]
    };
}

export const createTagUpdateDTO = (
    restaurantId: string, category: ReservationTagCategory,
    tagType: TagType, tag: ReservationTag, initialOrder: number, initialName: string, forDeletion = false): BatchCategoryUpdate | null => {

    const updateDTO = createTagCategoryUpdateDTO(restaurantId, category, tagType);
    updateDTO.batchUpdateTagCategories[0].op = "NONE";

    const isNew = Common.isNullOrEmpty(tag.id);
    const reordered = isNew || tag.tagOrder != initialOrder;
    const nameChanged = forDeletion || isNew || tag.title != initialName;

    //nothing changed, early exit
    if (!reordered && !nameChanged) {
        return null;
    }

    if (tag.tagOrder == null) {
        tag.tagOrder = category.tags.length + 1;
    }

    if (tag.tagOrder < 1) {
        tag.tagOrder = 1;
    }

    const newTag: TagDTO = {
        categoryId: category.id,
        id: isNew ? "" : tag.id,
        rule: "",
        tagOrder: tag.tagOrder,
        title: tag.title.trim(),
        op: isNew ? "CREATE" : "EDIT"
    };
    updateDTO.batchUpdateTagCategories[0].tags.push(newTag);

    if (forDeletion) {
        const sorted = category.tags.map(c => c)
            .filter(c => c.id != tag.id)
            .sort((a, b) => (a.tagOrder ?? 0) - (b.tagOrder ?? 0));

        let currentOrder = 1;
        for (let tag of sorted) {
            if (currentOrder != tag.tagOrder) {
                tag.tagOrder = currentOrder;
                updateDTO.batchUpdateTagCategories[0].tags.push(tagToRequestDTO(category, tag, false));
            }
            currentOrder++;
        }
    }

    if (!forDeletion && reordered) {
        const sorted = category.tags.map(c => c)
            .sort((a, b) => (a.tagOrder ?? 0) - (b.tagOrder ?? 0));

        let positionToInsert = tag.tagOrder - 1;

        if (positionToInsert == -1) {
            positionToInsert = 0;
        }

        //move to the correrct array position
        if (isNew) {
            sorted.splice(positionToInsert, 0, tag);
        } else {
            const existingPosition = sorted.findIndex(c => c.id == tag.id);
            if (existingPosition > -1 && existingPosition != positionToInsert) {
                sorted.splice(existingPosition, 1);
                sorted.splice(positionToInsert, 0, tag);
            }
        }

        //change order based on array index
        let currentOrder = 1;
        for (let cTag of sorted) {
            if (currentOrder != cTag.tagOrder) {
                cTag.tagOrder = currentOrder;
                const existing = updateDTO.batchUpdateTagCategories[0].tags.find(c => c.id == cTag.id);
                if (existing == null) {
                    updateDTO.batchUpdateTagCategories[0].tags.push(tagToRequestDTO(category, cTag, false));
                } else {
                    existing.tagOrder = currentOrder;
                }
            }
            currentOrder++;
        }
    }

    //console.log(updateDTO.batchUpdateTagCategories[0].tags);

    return updateDTO;
}

const tagToRequestDTO = (category: ReservationTagCategory, tag: ReservationTag, isNew: boolean): TagDTO => {
    return {
        categoryId: category.id,
        id: isNew ? "" : tag.id,
        rule: "",
        tagOrder: tag.tagOrder ?? 0,
        title: tag.title.trim(),
        op: isNew ? "CREATE" : "EDIT"
    }
}
